import { AxiosResponse } from 'axios';
import HttpStatus from 'model/enums/httpStatus';
import { PersonToProfile } from 'model/personAccount';
import { markError } from 'reducer/application/error/actions';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import accountApi from 'services/api/accountApi';
import { ErrorUtils } from 'shared/error/error-utils';
import {  personProfileError, personProfileSuccess } from './actions';
import { PersonProfileActionTypes } from './types';

function* handlePersonProfile() {
    try {
        const result: AxiosResponse<PersonToProfile> = yield call(accountApi.getProfile);
        if (result.status !== HttpStatus.OK) {
            const mapped = ErrorUtils.mapGiroIdhApiError(result);
            yield put(markError(mapped));
            yield put(personProfileError(mapped));
            return;
        }
        yield put(personProfileSuccess(result.data));
    } catch (error) {
        const mapped = ErrorUtils.mapLocalError(error);
        yield put(markError(mapped));
        yield put(personProfileError(mapped));
    }
}

function* watchPersonProfileRequest() {
    yield takeEvery(PersonProfileActionTypes.PERSON_PROFILE_REQUEST, handlePersonProfile);
}

function* personProfileSaga() {
    yield all([fork(watchPersonProfileRequest)]);
}

export default personProfileSaga;
